import {Component, OnDestroy, OnInit, Optional} from '@angular/core';
import {AppContainerOptions, AppContainerService, BackdropContainerEnum, IAppContainerFrame, ISwUpdateOptions, SwUpdateService, UserMenuItemsEnum} from '@mydocma/app-container';
import package_json from '../../../package.json';
import {UntilDestroy} from "@ngneat/until-destroy";
import {ConfigProvider} from '@mydocma/common';
import { firstValueFrom } from 'rxjs';
import { BackdropService } from '@mydocma/component-library/src/lib/backdrop';
import { JfConfig } from 'projects/mydocma/jf/src/lib/jf-config/jf-config.interface';
import { TaskScopeEnum, TaskService } from '@mydocma/task';

@UntilDestroy()
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, IAppContainerFrame, OnDestroy {
    public version: string = package_json.version;

    constructor(
        @Optional() public options: AppContainerOptions,
        private appContainerService: AppContainerService,
        private configService: ConfigProvider<JfConfig>,
        private readonly updateService: SwUpdateService,
        private backDropService: BackdropService,
        private readonly taskService: TaskService
    ) {
        this.appContainerService.notifyChanges((appContainer) => {
            appContainer.appIcon.name = this.configService.getConfigData().appName;
            appContainer.appIcon.color = this.configService.getConfigData().appIconColor;
            appContainer.header.customerSelection = false;
            appContainer.header.projectSelection = false;
            appContainer.header.userMenuItems.shouldShowLogs = false;
            appContainer.header.userMenuItems.shouldShowConnectivity = false;
            appContainer.header.userMenuItems.version = package_json.version;
            appContainer.disableCustomerProjectBlockingLoader = true;
            appContainer.header.userMenuItems.items.forEach(value => {
                if (value.id === UserMenuItemsEnum.userSettings) {
                    value.hidden = true;
                }
            })
        });

        this.updateService.attachBeforeSwUpdateCallback(this.beforeUpdate.bind(this));
    }

    private async beforeUpdate(): Promise<ISwUpdateOptions> {
        let canUpdate = true;

        const backDrops = await firstValueFrom(this.backDropService.activeBackdrops$);
        if (backDrops) canUpdate = backDrops.find(bd=> bd.options?.name === BackdropContainerEnum.MydocmaAppHeader) ? false : true;

        return {
            allowUpdate: true,
            showUpdateDialog: true
        }

    }

    ngOnDestroy(): void {}

    ngOnInit(): void {
        this.taskService.observeTasks([TaskScopeEnum.user]);
    }

    acOnRegister(appContainer: AppContainerOptions) {}

    acOnUnregister(appContainer: AppContainerOptions) {
        appContainer.sideNavBar.buttons = [];
        appContainer.topActionsBar.buttons = [];
    }
}
